// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vY7G","largestCol":"styles_largestCol__xOkxX","smallestCol":"styles_smallestCol__Jxk1j"};